import { API, graphqlOperation } from "aws-amplify";
import * as queries from "./../graphql/queries";
import { s3helper } from "../classes/s3helper";
import { Storage } from "aws-amplify";
import {
  createEventCompany,
  updateEventCompany,
  updateEvent
} from "./../graphql/mutations";
import { getEventCompany } from "./../graphql/queries";

export class Company {
  constructor() {}

  async listCompanys(nextToken) {
    const listEventCompanys = `query ListEventCompanys(
      $filter: ModelEventCompanyFilterInput
      $limit: Int
      $nextToken: String
      ) {
      listEventCompanys(filter: $filter, limit: $limit, nextToken: $nextToken) {
        items {
          id
          name
          email
          logo
          createdAt
          isDeleted
          event(
            filter: {
              isDeleted: { eq: 0 }
            }
          ) {
            items {
                id
                name
                status
                createdAt
            }
          }
        }
        nextToken
      }
    }`;

    const {
      data: { listEventCompanys: companys }
    } = await API.graphql(
      graphqlOperation(listEventCompanys, {
        filter: {
          isDeleted: {
            eq: 0
          }
        },
        limit: 50,
        nextToken: nextToken
      })
    );

    return companys;
  }

  async getCompany({ id }) {
    const {
      data: { getEventCompany: result }
    } = await API.graphql(
      graphqlOperation(getEventCompany, {
        id: id
      })
    );
    return result;
  }

  async createCompany({ name, logo, email }) {
    const isDuplicate = await this.isDuplicateCompany(name.trim());
    if (isDuplicate) {
      throw new Error("Company already exists.");
    }

    if (logo) {
      let file = logo;
      const fileName = file.name;
      const s3Key = s3helper.generateS3Key(fileName);
      const upload = await Storage.put("healthyevents/logo/" + s3Key, file, {
        level: "public",
        contentType: file.type
      });
      const {
        data: { createEventCompany: result }
      } = await API.graphql(
        graphqlOperation(createEventCompany, {
          input: {
            name: name.trim(),
            email: email.trim(),
            createdAt: new Date().toISOString(),
            logo: upload.key,
            logoFileName: fileName,
            isDeleted: 0
          }
        })
      );
      return result;
    } else {
      const {
        data: { createEventCompany: result }
      } = await API.graphql(
        graphqlOperation(createEventCompany, {
          input: {
            name: name.trim(),
            email: email.trim(),
            createdAt: new Date().toISOString(),
            isDeleted: 0
          }
        })
      );
      return result;
    }
  }

  async updateCompany({ id, name, email, logo }) {
    if (id) {
      if (logo) {
        this.updateCompanyLoader = true;
        let file = logo;
        const fileName = file.name;
        const s3Key = s3helper.generateS3Key(fileName);

        const upload = await Storage.put("healthyevents/logo/" + s3Key, file, {
          level: "public",
          contentType: file.type
        });

        const {
          data: { updateEventCompany: result }
        } = await API.graphql(
          graphqlOperation(updateEventCompany, {
            input: {
              id: id,
              name: name.trim(),
              email: email.trim(),
              createdAt: new Date().toISOString(),
              logo: upload.key,
              logoFileName: fileName,
              isDeleted: 0
            }
          })
        );
        return result;
      } else {
        const {
          data: { updateEventCompany: result }
        } = await API.graphql(
          graphqlOperation(updateEventCompany, {
            input: {
              id: id,
              name: name.trim(),
              email: email.trim(),
              createdAt: new Date().toISOString(),
              isDeleted: 0
            }
          })
        );
        return result;
      }
    }
  }

  async deleteCompany({ id }) {
    await API.graphql(
      graphqlOperation(updateEventCompany, {
        input: {
          id: id,
          isDeleted: 1
        }
      })
    );

    const getEventCompany = /* GraphQL */ `
      query GetEventCompany($id: ID!) {
        getEventCompany(id: $id) {
          event {
            items {
              id
            }
          }
        }
      }
    `;

    const {
      data: {
        getEventCompany: {
          event: { items: eventResults }
        }
      }
    } = await API.graphql(
      graphqlOperation(getEventCompany, {
        id: id
      })
    );
    eventResults.map(async event => {
      await API.graphql(
        graphqlOperation(updateEvent, {
          input: {
            id: event.id,
            isDeleted: 1
          }
        })
      );
    });

    return eventResults;
  }

  async deleteCompanyAttachment({ id }) {
    const {
      data: {
        updateEventCompany: {
          event: { items: results }
        }
      }
    } = await API.graphql(
      graphqlOperation(updateEventCompany, {
        input: {
          id: id,
          logo: null,
          logoFileName: null
        }
      })
    );
    return results;
  }

  async isDuplicateCode(code) {
    const eventByCode = /* GraphQL */ `
      query EventByCode(
        $sortDirection: ModelSortDirection
        $filter: ModelEventFilterInput
        $limit: Int
        $nextToken: String
      ) {
        eventByCode(
          code: "${code}"
          sortDirection: $sortDirection
          filter: $filter
          limit: $limit
          nextToken: $nextToken
        ) {
          items {
            id
            name
            code
            type
            requireDob
            iCalendar
            status
            message
            description
            commsTemplate
            bloodDropStart
            bloodDropEnd
            urinePotLocation
            preQuestionTemplate
            createdAt
            isDeleted
            updatedAt
          }
          nextToken
        }
      }
    `;
    const event = await API.graphql(
      graphqlOperation(eventByCode, {
        filter: { isDeleted: { eq: 0 } },
        limit: 100
      })
    );
    if (event.data.eventByCode.items.length > 0) {
      return true;
    }
    return false;
  }

  async isDuplicateCompany(companyName) {
    const {
      data: {
        listEventCompanys: { items: company }
      }
    } = await API.graphql(
      graphqlOperation(queries.listEventCompanys, {
        filter: { isDeleted: { eq: 0 }, name: { eq: companyName } },
        limit: 100
      })
    );
    if (company.length > 0) {
      return true;
    }
    return false;
  }
}
